import type { LeadCardHistoryItemData } from '@app/components/LeadCard/data';

export const LEAD_CRM_TASK_OBJECT_TYPE = 'CrmTask';

// Бэк пишет эти два текста ровно в одном случае — когда задачу завершили
// (HandlerChangeCrmTask, ветка EventChangeCrmTasks.SetCompleted). Остальные
// изменения задачи дают «добавил задачу», «изменил задачу», «вернул задачу в
// работу» и остаются обычной технической строкой истории.
const COMPLETED_TASK_ACTION_TEXTS = new Set([
  'завершил задачу',
  'завершила задачу',
]);

export const isCompletedTaskHistoryItem = ({
  ObjectType,
  ActionText,
}: LeadCardHistoryItemData): boolean =>
  ObjectType === LEAD_CRM_TASK_OBJECT_TYPE &&
  COMPLETED_TASK_ACTION_TEXTS.has((ActionText ?? '').trim().toLowerCase());
